




















  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import { namespace } from 'vuex-class'

  const products: BindingHelpers = namespace('products')

  @Component
  export default class OneMobileProductsList extends Vue {
    @products.Getter getSelectedAttributesCount: any;

    @Prop({
      type: Array,
    })
    sponsors: Array<any> | undefined

    @Prop({
      type: Array,
      required: true,
    })
    sortingOptions?: Array<any>

    @Prop({
      type: String,
      required: true,
    })
    initialSorting!: string

    get filtersCount() {
      return this.getSelectedAttributesCount > 0 ? `(${this.getSelectedAttributesCount})` : ''
    }
  }
